import { Colleague } from "../../../../features/Connections/types/Colleague.type";
import { VehicleBlockingEvent } from "../../types/FleetManagement.types";

/**
 * Enriches blocking events with createdByUser by resolving createdBy (user id) against the given users list.
 */
export function enrichBlockingEventsWithCreatedByUser(
  blockingEvents: VehicleBlockingEvent[],
  remoteUsers: Colleague[] | undefined
): VehicleBlockingEvent[] {
  return blockingEvents.map(be => {
    const createdByUser = be.createdBy
      ? remoteUsers?.find(u => u.userId === be.createdBy) ?? undefined
      : undefined;
    return {
      ...be,
      createdByUser: createdByUser
        ? {
            userId: createdByUser.userId,
            firstName: createdByUser.firstName,
            surname: createdByUser.surname,
            email: createdByUser.email,
            ...(createdByUser.photoUrl != null && { photoUrl: createdByUser.photoUrl })
          }
        : be.createdByUser
    };
  });
}
